import { render } from "./channelDialog.vue?vue&type=template&id=d47e9dd0&scoped=true"
import script from "./channelDialog.vue?vue&type=script&lang=js"
export * from "./channelDialog.vue?vue&type=script&lang=js"

import "./channelDialog.vue?vue&type=style&index=0&id=d47e9dd0&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47e9dd0"]])

export default __exports__